import axios from 'axios';
import config from "../config"

class CertficateService{

    getCertificate(student_id){
        let url = (config.MODE=="DEV" ? config.DEV : config.PROD).concat("/students/:students_id/certificates").bind(student_id);
        return new Promise((resolve,reject) => {
         axios.get(url)
         .then(res => {
            resolve(res.data);
         })
         .catch(err => reject(err.message));
       })
    }

}

export default new CertficateService;